var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"dom",staticClass:"wx-login tac"},[_c('div',{staticClass:"wx-login-inner",attrs:{"id":_vm.id}})])}
var staticRenderFns = []

export { render, staticRenderFns }